import { QueryState } from "src/app/core/models/query.model";
import { createTokenQueryServiceInstance } from "src/app/core/services/query-sentrynel.service";
import { SignalStoreConfig } from "src/app/shared/functions/store.functions";

export const IMPROVEMENT_ACTION_ENDPOINT = 'improvement-action';
export const IMPROVEMENT_ACTION_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(IMPROVEMENT_ACTION_ENDPOINT);


export const improvementActionStateConfig: SignalStoreConfig<QueryState<any>> = {
  initState: {
    list: []
  }
}


export const IMPROVEMENT_ACTION_DATATABLE_COLUMNS:any[] = [
  {
    name: 'id',
    label: 'Id',
    field: 'id',
    primaryKey: true,
    type:'text'
  },
  {
    name: 'description',
    label: 'Descrizione',
    field: 'description',
    type: 'text'

  },
  {
    name: 'actionType',
    label: 'Tipologia',
    field: 'actionType',
    type: 'text'

  },
  {
    name: 'target',
    label: 'Obiettivo',
    field: 'target',
    type: 'text'
  },
  {
    name: 'reason',
    label: 'Motivazione',
    field: 'reason',
    type: 'text'
  }
]

export const IMPROVEMENT_ACTION_DATATABLE_VISIBLE_COLUMNS = [
  'select',
  'description',
  'actionType',
  'target',
  'reason',
  'azioni'
]